// extracted by mini-css-extract-plugin
export default {"footerImg1":"Footer_footerImg1__G9FLe","footerImg2":"Footer_footerImg2__5e3Ai"};